const ENC_FLAG = 1;
const ENC_ALG = 'AES-256-GCM';

const KEY_B64 = process.env.REACT_APP_API_ENC_KEY_B64
  ? process.env.REACT_APP_API_ENC_KEY_B64.trim()
  : '';
let keyPromise = null;

function base64ToUint8(b64) {
  const binary = globalThis.atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
}

function isEncryptedPayload(data) {
  return (
    data &&
    typeof data === 'object' &&
    data.enc === ENC_FLAG &&
    data.alg === ENC_ALG &&
    typeof data.iv === 'string' &&
    typeof data.tag === 'string' &&
    typeof data.data === 'string'
  );
}

async function getKey() {
  if (!KEY_B64) {
    return null;
  }

  if (!keyPromise) {
    const keyBytes = base64ToUint8(KEY_B64);
    keyPromise = globalThis.crypto.subtle.importKey(
      'raw',
      keyBytes,
      'AES-GCM',
      false,
      ['decrypt']
    );
  }

  return keyPromise;
}

async function decryptPayload(payload) {
  const key = await getKey();
  if (!key) {
    return payload;
  }

  const iv = base64ToUint8(payload.iv);
  const ciphertext = base64ToUint8(payload.data);
  const tag = base64ToUint8(payload.tag);
  const combined = new Uint8Array(ciphertext.length + tag.length);
  combined.set(ciphertext);
  combined.set(tag, ciphertext.length);

  const plaintext = await globalThis.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv },
    key,
    combined
  );

  const text = new globalThis.TextDecoder().decode(new Uint8Array(plaintext));
  return JSON.parse(text);
}

export async function maybeDecryptResponse(data) {
  let payload = data;
  if (typeof payload === 'string') {
    try {
      payload = JSON.parse(payload);
    } catch (err) {
      return data;
    }
  }

  if (!isEncryptedPayload(payload)) {
    return data;
  }

  try {
    return await decryptPayload(payload);
  } catch (err) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn('Response decryption failed', err);
    }
    return data;
  }
}
